import { useMemo } from 'react'

import { UnorderedListOutlined } from '@ant-design/icons'
import { useRequest } from 'ahooks'
import { Button, Popover } from 'antd'
import { isNil } from 'lodash'

import { queryKindRootNodesApi } from '@eastcoal/api/system/kind/queryKindRootNodes'

import { stringifyUrl } from '@eastcoal/common/utils/querystring'

import { useNavigate } from '@eastcoal/router/exports/react-router'
import { BizType } from '@eastcoal/shared/enums/BizType'

import { LISTING_LIST_PAGE_PATH } from '../../../../pages/Listing/constants/path'
import { TRADE_SESSION_LIST_PAGE_PATH } from '../../../../pages/TradeSession/List/constants/path'

import { useStyles } from './style'

const groups = [
  {
    key: 'auction_tradeMode',
    title: '竞价-交易模式',
    path: TRADE_SESSION_LIST_PAGE_PATH,
    field: 'bizType',
    children: [
      {
        key: 'auction_tradition',
        title: '竞拍',
        value: BizType.TRADITION_AUCTION
      },
      {
        key: 'auction_ranking',
        title: '竞拍（排名）',
        value: BizType.RANKING_AUCTION
      },
      {
        key: 'auction_house',
        title: '竞价（房屋）',
        value: BizType.HOUSE_AUCTION
      },
      {
        key: 'auction_secret',
        title: '密函',
        value: BizType.SECRET_AUCTION
      },
      {
        key: 'acution_inquiry',
        title: '询比价',
        value: BizType.INQUIRY_AUCTION
      },
      {
        key: 'auction_tender',
        title: '招标',
        value: BizType.TENDER_AUCTION
      },
      {
        key: 'price_compare',
        title: '比价采购',
        value: BizType.PRICE_COMPARE
      }
    ]
  },
  {
    key: 'auction_subjectMode',
    title: '竞价-标的物模式',
    path: TRADE_SESSION_LIST_PAGE_PATH,
    field: 'kindNode',
    children: [
      {
        key: 'baking_coal',
        title: '炼焦煤',
        value: null
      },
      {
        key: 'steam_coal',
        title: '动力煤',
        value: null
      },
      {
        key: 'coking_coal',
        title: '焦炭',
        value: null
      },
      {
        key: 'blind_coal',
        title: '无烟煤',
        value: null
      },
      {
        key: 'junk',
        title: '废旧物资',
        value: null
      },
      {
        key: 'second_hand_equipment',
        title: '二手设备',
        value: null
      },
      {
        key: 'project_contract',
        title: '项目承包',
        value: null
      },
      {
        key: 'maintenance_items',
        title: '维修项目',
        value: null
      },
      {
        key: 'pvc_products',
        title: 'PVC产品',
        value: null
      },
      {
        key: 'kaolin',
        title: '高岭土',
        value: null
      },
      {
        key: 'coalite',
        title: '煤化品',
        value: null
      },
      {
        key: 'house',
        title: '房屋',
        value: null
      },
      {
        key: 'build_material_products',
        title: '建材类产品',
        value: null
      }
    ]
  },
  {
    key: 'listing_goodsCategory',
    title: '挂牌-商品类型',
    path: LISTING_LIST_PAGE_PATH,
    field: 'kindNode',
    children: [
      {
        key: 'baking_coal',
        title: '炼焦煤',
        value: null
      },
      {
        key: 'steam_coal',
        title: '动力煤',
        value: null
      },
      {
        key: 'coking_coal',
        title: '焦炭',
        value: null
      },
      {
        key: 'blind_coal',
        title: '无烟煤',
        value: null
      }
    ]
  }
] as const

export const CategoryDropdown = () => {
  const navigate = useNavigate()
  const { data: kindNodes } = useRequest(queryKindRootNodesApi, {
    manual: false
  })

  const { styles } = useStyles()

  const content = useMemo(
    () =>
      groups.map(({ key, title, field, path, children }) => (
        <div key={key} className={styles.group}>
          <h3 className={styles.title}>{title}</h3>
          <div className={styles.items}>
            {children.map(({ key, title, value }) => (
              <div key={key} className={styles.item}>
                <Button
                  size='small'
                  type='text'
                  onClick={() => {
                    const searchValue = isNil(value)
                      ? kindNodes?.filter(kind => kind.name === title)?.[0]
                      : value

                    navigate(
                      stringifyUrl({
                        url: `${path}`
                      }),
                      {
                        state: {
                          [`${field}`]: searchValue
                        }
                      }
                    )
                  }}
                >
                  {title}
                </Button>
              </div>
            ))}
          </div>
        </div>
      )),
    [kindNodes, navigate, styles]
  )

  return (
    <Popover
      arrow={false}
      content={content}
      getPopupContainer={triggerNode => triggerNode}
      placement='bottomLeft'
      rootClassName='test'
      align={{
        offset: [0, 0]
      }}
    >
      <div className={styles.button} role='button' tabIndex={0}>
        <UnorderedListOutlined />
        <span>竞价及挂牌分类</span>
      </div>
    </Popover>
  )
}
